import moment from 'moment';
import { fetchApi, React, PT, withRouter } from '@gasbuddy/react';
import { Segment, Header, Message, Button } from 'semantic-ui-react';

class BaseTransactionAuthTools extends React.Component {
  state = {}

  goToTx = (e) => {
    e.preventDefault();
    const { transactionAuth, history } = this.props;
    history.push(`/payments/transaction/${transactionAuth.account_id}/${transactionAuth.transaction_id}`);
  };

  updateTransactionAuth = (e) => {
    e.preventDefault();
    const { transactionAuth, onChange } = this.props;
    this.setState({ loading: true }, async () => {
      const { status, body, error } = await fetchApi({
        url: '/devtools/transaction-auth/update',
        body: {
          txAuth: transactionAuth,
          authStatus: 'authorized',
          amount: '23.45',
          authTime: moment().subtract(31, 'minutes').toISOString(),
        },
      });
      if (status === 200) {
        this.setState({ loading: false, error: null }, onChange);
      } else {
        this.setState({ loading: false, error: error || body });
      }
    });
  };

  postTransactionAuth = (e) => {
    e.preventDefault();
    const { transactionAuth, onChange } = this.props;
    this.setState({ loading: true }, async () => {
      const { status, body, error } = await fetchApi({
        url: '/devtools/transaction-auth/update',
        body: {
          txAuth: transactionAuth,
        },
      });
      if (status === 200) {
        this.setState({ loading: false, error: null }, onChange);
      } else {
        this.setState({ loading: false, error: error || body });
      }
    });
  };

  render() {
    const { transactionAuth } = this.props;
    const { loading, error } = this.state;
    return (
      <div style={{ marginTop: 15 }}>
        <Header as="h3" block attached="top">
          Dev Tools
        </Header>
        <Segment attached loading={loading}>
          {error
            && (
              <Message error>
                Unable to post transaction auth:
                <pre>{JSON.stringify(error, null, '\t')}</pre>
              </Message>
            )
          }
          {transactionAuth && transactionAuth.auth_status === 'pre_authorized'
            && <Button onClick={this.updateTransactionAuth}>Authorize Tx Auth</Button>}
          {transactionAuth && transactionAuth.auth_status === 'authorized'
            && <Button onClick={this.postTransactionAuth}>Post Tx Auth</Button>}
          {transactionAuth && transactionAuth.auth_status === 'posted'
            && transactionAuth.transaction_id
            && <Button onClick={this.goToTx}>Go To Tx</Button>}
        </Segment>
      </div>
    );
  }
}

BaseTransactionAuthTools.propTypes = {
  transactionAuth: PT.shape({
    account_id: PT.number,
    amount: PT.string,
    auth_code: PT.string,
    auth_status: PT.string,
    auth_time: PT.string,
    created_at: PT.string,
    external_auth_id: PT.string,
    instrument_account_map_id: PT.number,
    instrument_id: PT.number,
    transaction_auth_id: PT.number,
    merchant: PT.shape({
      merchant_id: PT.number,
      merchant_name: PT.string,
      internal_name: PT.string,
      address: PT.shape({
        line_1: PT.string,
        locality: PT.string,
        region: PT.string,
        postal_code: PT.string,
      }),
    }),
    transaction_id: PT.number,
  }),
  onChange: PT.func.isRequired,
  history: PT.shape({ push: PT.func }).isRequired,
};

BaseTransactionAuthTools.defaultProps = {
  transactionAuth: {},
};

export const TransactionAuthTools = withRouter(BaseTransactionAuthTools);
